import { request } from '@blade/common';
// 搜索中心事件列表
export const eventtype = () => request
    .get('/api/timedb-management/api/v1/search/query/eventtype');
// 搜索中心事件搜索
export const eventTypes = (data) => request
    .post('/api/timedb-management/api/v1/search/query/search', data);
// export const eventTypes = (data: EventType) => request 澳门水库
//   .post('/api/timedb-management/api/v1/search/image', data);
// 搜索中心特征图片上传
export const detectTypes = (data) => request
    .post('/api/timedb-management/api/v1/search/image/detect', data);
// 搜索中心新增路径
export const trackSpace = (data) => request
    .post('/api/timedb-management/api/v1/track/space', data);
// 搜索中心删除路径
export const deleteTrack = (data) => request
    .delete(`/api/timedb-management/api/v1/track/${data}`);
// 删除所有路径
export const cleanAll = () => request
    .delete('/api/timedb-management/api/v1/track/clean/all');
// 删除特征路径路径
export const deleteImg = (data) => request
    .delete('/api/timedb-management/api/v1/track/delete/type', { data });
// 获取所有路径
export const allTrack = () => request
    .get('/api/timedb-management/api/v1/track/query/all');
// 获取轨迹列表 -zrl
export const TrackList = () => request
    .get('/api/timedb-management/api/v1/track/query/list');
// 删除列表 -zrl
export const delTrackList = (id) => request
    .delete(`/api/timedb-management/api/v1/track/${id}`);
export const mapQuery = (zoneId, permissionCode) => request({
    url: `/api/map-management/api/v1/map/query/${zoneId}`,
    method: 'POST',
    data: {
        sceneCode: permissionCode
    }
});
export const trackDevices = (id) => request({
    url: `/api/timedb-management/api/v1/track/query/${id}`,
    method: 'GET',
});
// 获取父轨迹地图
export const parentTrackDevices = (id) => request({
    url: `/api/timedb-management/api/v1/track/get/parentzone/${id}`,
    method: 'GET',
});
// 获取事件搜索类型枚举 2.2.1 -zrl
export const getSearchType = (data) => {
    return request({
        url: `/api/user-management/api/v1/hardDogAuthorization/getHardDogAuthorizationLabel`,
        method: 'POST',
        data
    });
};
// 获取事件搜索属性枚举 2.2.1 -zrl
export const getAttributes = () => {
    return request({
        url: `/api/timedb-management/api/v1/search/query/attributes`,
        method: 'GET',
    });
};
// 获取所有特征
export const getFeatures = () => request({
    url: `/api/timedb-management/api/v1/search/query/attributes`,
    method: 'GET',
});
// 新增脑图
export const addMinMapNode = (data) => request({
    url: `/api/timedb-management/api/v1/track/add/mindMap/node`,
    method: 'POST',
    data
});
// 获取所有脑图节点
export const getAllMinMapApi = () => request({
    url: `/api/timedb-management/api/v1/track/query/mindMap`,
    method: 'GET',
});
// 删除脑图节点
export const deletdMinMapApi = (relationId) => request
    .delete(`/api/timedb-management/api/v1/track/delete/mindMap/node/${relationId}`);
// 清空脑图节点
export const deletdAllMinMapApi = () => request
    .delete('/api/timedb-management/api/v1/track/clean/mindMap');
// 获取所有脑图节点
export const getMindMapsApi = (data) => request({
    url: `/api/timedb-management/api/v1/track/user/mindMaps`,
    method: 'POST',
    data
});
// 删除列表脑图节点
export const deleteMindMapsApi = (data) => request({
    url: `/api/timedb-management/api/v1/track/delete/type`,
    method: 'delete',
    data
});
